/* 
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
/**
 * @IonSpinnerTemplate
 * 
 * string html template that gets parsed and rendered as html 
 * by Ag grid. Replace their default spinner. 
 * 
 * <AgGridReact overlayLoadingTemplate={IonSpinnerTemplate} />
 */
export const IonSpinnerTemplate = '<div class="spinner" style="width: 45px; height: 45px; margin-top: 45px;"><div class="circle circle1"></div><div class="circle circle2"></div><div class="circle circle3"></div></div>';
